import { BrowserRouter, Route, Routes } from 'react-router'
import { MainLayout } from '@/components/layout'
import { PageSeo } from '@/components/common'
import {
  HomePage,
  AboutPage,
  ServicesPage,
  EnquiryPage,
  NotFoundPage,
  HerJourneyHubPage,
  FAQPage,
  StoriesPage,
} from '@/pages'
import { ROUTES } from '@/constants/routes'

const GlobalRoute = () => (
  <BrowserRouter>
    <PageSeo />
    <Routes>
      <Route element={<MainLayout />}>
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.ABOUT} element={<AboutPage />} />
        <Route path={ROUTES.SERVICES} element={<ServicesPage />} />
        <Route path={ROUTES.ENQUIRY} element={<EnquiryPage />} />
        <Route path={ROUTES.HER_JOURNEY_HUB} element={<HerJourneyHubPage />} />
        <Route path={ROUTES.FAQ} element={<FAQPage />} />
        <Route path={ROUTES.STORIES} element={<StoriesPage />} />
        <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
      </Route>
    </Routes>
  </BrowserRouter>
)

export default GlobalRoute
